import { render, staticRenderFns } from "./loginConfiguration.vue?vue&type=template&id=8b21f3f8&scoped=true&"
import script from "./loginConfiguration.vue?vue&type=script&lang=js&"
export * from "./loginConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b21f3f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b21f3f8')) {
      api.createRecord('8b21f3f8', component.options)
    } else {
      api.reload('8b21f3f8', component.options)
    }
    module.hot.accept("./loginConfiguration.vue?vue&type=template&id=8b21f3f8&scoped=true&", function () {
      api.rerender('8b21f3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/loginConfiguration.vue"
export default component.exports